import { handleRfcData } from "views/Closeouts-Settlements/actions/fetchData";
import { useDispatch, useSelector } from 'react-redux';
import { useFetchLocal } from "hooks/fetch-hooks/useFetchLocal";
import { useEffect, useState } from "react";
import { setDataToSend } from "redux/actions/invoices/invoicesCashAction";
import { useSearch } from "hooks/useSearch";
import { verifyRFC } from "helpers/validation";
import { regimensData } from "enums/regimens";
import { paymentsInvoicesType } from "helpers/dictionary";
import { typePayment, reasonNotesOptions, receiverDefaults } from "./config"

const { toBeDefined, rfcForeign, regimeForeign, satUsageForeign, cpForeign, satCodesNoPaymentMethod } = receiverDefaults

export const useReceiverHook = ({ setValues, setFieldErrors, values, validate, reset }) => {
  const dispatch = useDispatch()
  const {
    searchCustomer,
    idAccount,
    rfc,
    emails,
    regime,
    satUsage,
    cp,
    paymentType,
    paymentMethod,
    companyName,
    editData
  } = values
  const { readyToSend, clearForm } = useSelector(({ cashInvoices }) => cashInvoices)
  const { reasonSelect } = useSelector(({ cashInvoices }) => cashInvoices)
  const { payments } = useSelector(({ deposits }) => deposits);
  const { setSnackbar } = useSearch();
  const { satUsages } = useSelector(({ creditNotes }) => creditNotes);
  const [
    [_data, loading, _success, error, _message],
    fetchCustomers,
  ] = useFetchLocal(handleRfcData);
  const [mapPayments, setMapPayments] = useState([])

  const handleRfc = (e) => {
    const { name, value } = e.target;
    const cleanValue = value
      .toUpperCase()
      .replace(/\s/g, '')
      .slice(0, 13);
    setValues({ [name]: cleanValue });
  }

  const handleEditData = (e) => {
    e.preventDefault()
    setValues({ editData: !editData })
  }

  const submit = (e) => {
    e.preventDefault()
    if (!verifyRFC(searchCustomer)) {
      setFieldErrors({ searchCustomer: "RFC inválido" })
      return;
    }

    fetchCustomers(searchCustomer, setValues, dispatch, setFieldErrors);
  }

  const saveData = async () => {
    const data = {
      rfc: rfc?.trim(),
      companyName: companyName?.trim(),
      email: emails.join(", "),
      regime: regime.value,
      useCFDI: satUsage.code,
      cp,
      paymentType: paymentType.value,
      paymentMethod: paymentMethod.value,
    }
    const dataFiscalSave = {
      rfc: rfc?.trim(),
      name: companyName?.trim(),
      email: emails[0],
      postal_code: cp,
      sat_cfdi_use_code: satUsage.code,
      sat_tax_regime_code: regime.value,
      paymentType: paymentType.value,
      paymentMethod: paymentMethod.value,
    }
    dispatch(setDataToSend('receiver', { ...data, receiverExists: editData && idAccount ? dataFiscalSave : null }))
  }

  const handleChangePaymentMethod = (e) => {
    if (e?.paymentMethod?.value === typePayment.pue && paymentType?.satCode === toBeDefined) {
      setValues({ paymentType: null })
    }
    if (e?.paymentMethod?.value === typePayment.ppd) {
      setValues({ paymentType: payments.find(payment => payment?.satCode === toBeDefined) })
    }
    setValues(e)
  }

  const handlePaymentType = (e) => {
    if (e?.paymentType?.satCode === toBeDefined && paymentMethod?.value === typePayment.pue) {
      setSnackbar("No puede ser PUE con 99", "warning")
      return;
    }
    setValues(e);
  }

  useEffect(() => {
    if (!idAccount) {
      reset()
      return;
    }
    let nEmails = [...emails]
    if (idAccount?.email) {
      nEmails = [idAccount?.email, ...emails]
    }

    setValues({
      email: idAccount?.email || "",
      rfc: idAccount?.rfc || "",
      companyName: idAccount?.name,
      cp: idAccount?.postalCode || "",
      emails: nEmails,
      satUsage: satUsages?.find((usage) => usage.code === idAccount?.satCfdiUseCode) || "",
      regime: regimensData.find((regimen) => regimen.value === idAccount?.satTaxRegimeCode) || "",
    })
  }, [idAccount])

  useEffect(() => { readyToSend && validate([], saveData) }, [readyToSend])

  useEffect(() => {
    if (payments?.length > 0) {
      setMapPayments(payments.filter(payment => !satCodesNoPaymentMethod.includes(payment.satCode))
        .map(payment => payment = { ...payment, label: `${payment.satCode} - ${payment.label}` }))
    }
  }, [payments])

  useEffect(() => {
    if (reasonSelect === reasonNotesOptions.foreign) {
      setValues({
        editData: true,
        rfc: rfcForeign,
        cp: cpForeign,
        regime: regimensData.find(regimen => regimen.value === regimeForeign),
        satUsage: satUsages?.find(usage => usage.code === satUsageForeign),
        paymentMethod: paymentsInvoicesType.find(payment => payment.value === typePayment.pue),
        paymentType: null,
      })
    }
    if (reasonSelect !== reasonNotesOptions.foreign && rfc === rfcForeign) {
      setValues({ editData: false, rfc: "", cp: "", regime: null, satUsage: null })
    }
  }, [reasonSelect])

  useEffect(() => {
    if (clearForm) {
      reset()
    }
  }, [clearForm])

  return {
    submit,
    handleRfc,
    loading, error,
    mapPayments,
    handleChangePaymentMethod,
    handlePaymentType,
    setFieldErrors,
    handleEditData,
  }
}